import { useEffect, useState } from 'react';
import axios from 'axios';
import { Timer, TrendingUp } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('futurepath_token')}` } });

export function TimeSavedPanel({ refreshKey }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API}/counselor/time-saved`, auth())
      .then(r => setData(r.data)).catch(() => setData(null));
  }, [refreshKey]);

  if (!data) return null;

  return (
    <div className="rounded-2xl border p-6 backdrop-blur-xl" data-testid="time-saved-panel"
      style={{ background: 'linear-gradient(140deg, rgba(16,44,72,0.85), rgba(13,27,46,0.75))',
               borderColor: 'rgba(125,211,252,0.24)' }}>
      <div className="flex flex-wrap items-end justify-between gap-6">
        <div>
          <p className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.16em] text-sky-200">
            <Timer className="h-3.5 w-3.5" /> Time saved this month
          </p>
          <p className="font-outfit mt-2 text-5xl font-bold text-white tabular-nums" data-testid="time-saved-hours">
            {data.hours_this_month}<span className="ml-2 text-xl font-medium text-slate-300">hours</span>
          </p>
          <p className="mt-1 text-xs text-slate-300">
            {data.actions_this_month} actions · {data.hours_all_time} hours since you started
          </p>
        </div>
        <div className="flex flex-wrap gap-x-8 gap-y-3">
          {data.breakdown.slice(0, 4).map(b => (
            <div key={b.action} data-testid={`time-saved-${b.action}`}>
              <p className="text-lg font-semibold text-white tabular-nums">{b.count}</p>
              <p className="text-[11px] text-slate-300">{b.label}</p>
              <p className="text-[10.5px] text-sky-300">{b.minutes} min saved</p>
            </div>
          ))}
          {data.breakdown.length === 0 && (
            <p className="flex items-center gap-2 text-xs text-slate-300">
              <TrendingUp className="h-3.5 w-3.5" /> Send a nudge or publish meeting times to start the clock
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
